import { alpha } from '@mui/material/styles';

/**
 * Chat-specific theme extensions
 * Extends unifiedTheme with chat component styles
 */
export const chatTheme = {
  // Chat container styles
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f6f6f6',
    borderRadius: '16px',
    overflow: 'hidden',
  },
  
  // Message list styles
  messageList: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: '100%',
    minHeight: 0,
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: alpha('#000', 0.2),
      borderRadius: '4px',
      '&:hover': {
        background: alpha('#000', 0.3),
      },
    },
  },
  
  // Message bubble styles
  messageBubble: {
    sent: {
      alignSelf: 'flex-end',
      maxWidth: '70%',
      backgroundColor: '#ef4192',
      color: '#fff',
      borderRadius: '16px 16px 4px 16px',
      padding: '12px 16px',
      boxShadow: '0px 2px 4px rgba(0,0,0,0.06)',
    },
    received: {
      alignSelf: 'flex-start',
      maxWidth: '70%',
      backgroundColor: '#fff',
      color: '#2C3E50',
      borderRadius: '16px 16px 16px 4px',
      padding: '12px 16px',
      boxShadow: '0px 2px 4px rgba(0,0,0,0.06)',
      border: '1px solid rgba(0, 0, 0, 0.08)',
    },
    ai: {
      alignSelf: 'flex-start',
      maxWidth: '75%',
      backgroundColor: '#fff',
      color: '#2C3E50',
      borderRadius: '16px 16px 16px 4px',
      padding: '12px 16px',
      boxShadow: '0px 2px 4px rgba(0,0,0,0.06)',
      border: '1px solid rgba(239, 65, 146, 0.2)',
      position: 'relative',
    },
  },
  
  // Message input styles
  messageInput: {
    container: {
      padding: '16px',
      backgroundColor: '#fff',
      borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    },
    input: {
      borderRadius: '24px',
      backgroundColor: '#f6f6f6',
      '& .MuiOutlinedInput-root': {
        borderRadius: '24px',
        '& fieldset': {
          border: 'none',
        },
        '&:hover fieldset': {
          border: 'none',
        },
        '&.Mui-focused fieldset': {
          border: 'none',
        },
      },
    },
    sendButton: {
      borderRadius: '50%',
      minWidth: '48px',
      width: '48px',
      height: '48px',
      backgroundColor: '#ef4192',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#d63882',
      },
      '&:disabled': {
        backgroundColor: alpha('#ef4192', 0.5),
      },
    },
  },
  
  // Conversation sidebar styles
  sidebar: {
    container: {
      width: '100%',
      maxWidth: '320px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      marginBottom: '10px',
    },
    conversationItem: {
      padding: '12px 16px',
      cursor: 'pointer',
      gap: '12px',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: 'rgba(239, 65, 146, 0.04)',
      },
      '&.active': {
        backgroundColor: 'rgba(239, 65, 146, 0.08)',
      },
    },
  },
  
  // Function call indicator styles
  functionCallIndicator: {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 12px',
      backgroundColor: alpha('#ef4192', 0.1),
      borderRadius: '8px',
      marginTop: '8px',
      fontSize: '0.875rem',
      color: '#ef4192',
    },
    icon: {
      animation: 'pulse 2s infinite',
    },
  },
  
  // Typing indicator styles
  typingIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '12px 16px',
    '& span': {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#9e9e9e',
      animation: 'typing 1.4s infinite',
      '&:nth-of-type(2)': {
        animationDelay: '0.2s',
      },
      '&:nth-of-type(3)': {
        animationDelay: '0.4s',
      },
    },
  },
};

// Keyframe animations
export const chatAnimations = `
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  
  @keyframes typing {
    0%, 60%, 100% {
      transform: translateY(0);
      opacity: 0.7;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

export default chatTheme;

